import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { throwError, from as fromPromise } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { AuthService } from '../modules/auth/services/auth.service';

export const TokenInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {

  const authService = inject(AuthService);

  return next(applyToken(authService, request)).pipe(
    catchError((error: any) => {
      if ((error instanceof HttpErrorResponse) && (error.status === 401)) {

        // Ask for credentials
        return fromPromise(authService.signIn('refresh-session'))
          .pipe(switchMap(() => next(applyToken(authService, request))));
      } else {
        return throwError(() => error);
      }
    })
  );
}

// If authenticated, append token to the passed request and return modified request
function applyToken(authService: AuthService, request: HttpRequest<any>): HttpRequest<any> {

  // Get session info
  const sessionInfo = authService.getSessionInfo();

  // If authenticated, add token to request params
  if (sessionInfo) {
    const params = request.params.set('uuid', sessionInfo.TokenId);
    request = request.clone({ params: params });
  }

  return request;
}
